import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=f1ed7186&scoped=true&lang=pug&"
import script from "./group-detail.vue?vue&type=script&lang=js&"
export * from "./group-detail.vue?vue&type=script&lang=js&"
import style0 from "./group-detail.vue?vue&type=style&index=0&id=f1ed7186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ed7186",
  null
  
)

export default component.exports